import React from 'react';
import { motion } from 'framer-motion';
import galleryImage1 from '../style/thermal_img/industrial-oven-1754080.jpg';
import galleryImage2 from '../style/thermal_img/CARTRIDGE HEATERS.jpg';
import galleryImage3 from '../style/thermal_img/CERAMIC HEATERS.jpg';
import galleryImage4 from '../style/thermal_img/COIL HEATERS.jpg';
import galleryImage5 from '../style/thermal_img/INDUSTRIAL HEATERS.jpg';
import galleryImage6 from '../style/thermal_img/FLANGED IMMERSION HEATERS.jpg';
// import galleryImage7 from '../style/images/col_1.jpeg';
// import galleryImage8 from '../style/images/Gro_driveEvent2.jpeg';
import galleryImage9 from '../style/thermal_img/FURNACE.jpg';
import galleryImage01 from '../style/thermal_img/HIGH DENSITY HEATERS.jpg';
import galleryImage02 from '../style/thermal_img/HTR bank.jpg';
import galleryImage03 from '../style/thermal_img/MICA BAND HEATERS.jpg';
import galleryImage04 from '../style/thermal_img/IMMERSION HEATERS.jpg';
import galleryImage05 from '../style/thermal_img/oven 111.jpg';
import galleryImage10 from '../style/thermal_img/images (2).jpg';
import galleryImage11 from '../style/thermal_img/images (3).jpg';
import galleryImage12 from '../style/thermal_img/images (4).jpg';
import galleryImage13 from '../style/thermal_img/images (5).jpg';
import galleryImage14 from '../style/thermal_img/images (6).jpg';
import galleryImage15 from '../style/thermal_img/images (7).jpg';
import galleryImage17 from '../style/thermal_img/images (8).jpg';
import galleryImage18 from '../style/thermal_img/images (9).jpg';
import galleryImage19 from '../style/thermal_img/images (10).jpg';
import galleryImage20 from '../style/thermal_img/images (11).jpg';
import galleryImage21 from '../style/thermal_img/images.jpg';
// import galleryImage22 from '../style/thermal_img/';
// import galleryImage23 from '../style/images/gallery23.jpeg';
// import galleryImage24 from '../style/images/gallery24.jpeg';
// import galleryImage25 from '../style/images/gallery25.jpeg';
// import galleryImage26 from '../style/images/gallery26.jpeg';
// import galleryImage27 from '../style/images/gallery27.jpeg';
// import galleryImage28 from '../style/images/gallery28.jpeg';





const images = [
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  // galleryImage7,
  // galleryImage8,
  galleryImage9,
  // galleryImage01,
  galleryImage02,
  galleryImage03,
  galleryImage04,
  galleryImage05,
  galleryImage10,
  galleryImage11,
  galleryImage12,
  galleryImage13,
  galleryImage14,
  galleryImage15,
  galleryImage17,
  galleryImage18,
  galleryImage19,
  galleryImage20,
  galleryImage21,
  // galleryImage22,
  // galleryImage23,
  // galleryImage24,
  // galleryImage25,
  // galleryImage26,
  // galleryImage27,
  // galleryImage28,
];

const Gallery = () => {
  return (
    <section id="products" className="gallery-section">
      <div className="container">
        <motion.h2
          className="gallery-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Products
          <div className="section-divider"></div>
        </motion.h2>

        <div className="gallery-masonry">
          {images.map((src, index) => (
            <motion.div
              key={index}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src} alt={`Gallery ${index + 1}`} loading="lazy" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
